// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Countdown_countdown__2XhtZ","orange":"Countdown_orange__3ons2","white":"Countdown_white__2r5g6","yellow":"Countdown_yellow__3ZIH8"};